module.exports = __webpack_public_path__ + "img/Background_grey.073234f1.png";